import React, { useEffect, useRef, useState } from 'react';
import { doPost } from "../../utils/services/api/API"
import { connect } from "react-redux";
import { UPDATE_USER_DETAILS } from '../../store/actions'
import {
    Text, View, Image, Switch,
    StyleSheet, Linking, Keyboard, Pressable
} from 'react-native';
import { LinearGradient } from 'expo-linear-gradient';

import { updateUserLoginDetails } from "../../utils/services/redux/commonRedux";
import { validatePhoneNumber, validateUserName } from '../../utils/services/DataValidity';
import { OMSOrderDataSubscription } from '../../utils/services/subject-behaviour/CommonRxjsService';
import { MoengageEvents, trackMoengageEvents } from '../../utils/services/webapp-services/MoengageUtils';

import { CommonHeader } from '../../utils/widgets/CommonWidget/CommonHeader';
import { addFontFamilyStyle, getImagePath } from "../../utils/services/CommonUtils";
import { NameTextInput, PhoneNumberTextInput } from '../../utils/widgets/CommonTextInput';

import { ScreenRoute } from '../../utils/constants/ScreenRouteConstant';

import AppTheme from '../../AppTheme';
import AppStyles from '../../AppStyles';
import TextStyle from '../../TextStyle';

import * as AlertService from "../../utils/services/AlertLoaderService";

const LoginScreen = (props) => {
    const [phoneNumber, setPhoneNumber] = useState('');
    const [enabled, setEnabled] = useState(false);
    const [waUpdates, waUpdatesSet] = useState(true);

    const [userName, setName] = useState('');
    const [omsFlow, setOMSFlow] = useState(false)
    const [profileExist, setProfileExist] = useState(null)

    useEffect(() => {
        Keyboard.addListener('keyboardDidShow', () => { });
        Keyboard.addListener('keyboardDidHide', () => { });

        OMSOrderDataSubscription.getomsOrderData().
            subscribe((orderDataSubscription: any) => {
                let userUpdatedData: any = orderDataSubscription.userUpdatedData;
                if (userUpdatedData?.['name']) {
                    setOMSFlow(true)
                    setProfileExist(true)
                }
            }).unsubscribe()

    })

    const onChangePhoneNumber = (phoneNumber) => {
        if (!omsFlow) setProfileExist(null)
        setPhoneNumber(phoneNumber)
        setEnabled(validatePhoneNumber(phoneNumber))
    }

    const onSendOTP = () => {
        if (validatePhoneNumber(phoneNumber)) {
            if (profileExist == null) checkProfileExists(phoneNumber)
            else if (profileExist || validateUserName(userName))
                sendOTP(phoneNumber)
        }
    }

    function checkProfileExists(phoneNumber) {
        doPost('account/profile_exists', { phoneNumber: phoneNumber }, false).
            then((response) => {
                setProfileExist(response['exists'])
                if (response['exists']) {
                    sendOTP(phoneNumber)
                }
            }).catch(err => { console.log(err) })
    }

    async function sendOTP(phoneNumber) {
        AlertService.loaderModal.setLoader(true, 0.6)
        let params = {
            phoneNumber: phoneNumber,
            origin: location.host
        }
        doPost('accounts/send_otp', params, false)
            .then((response) => {
                trackMoengageEvents(MoengageEvents.login_started);
                updateUserLoginDetails({
                    phoneNumber: phoneNumber,
                    waupdate: waUpdates,
                    navigateFrom: global.navigateFrom
                })
                var otpData = { phoneNumber: phoneNumber, waUpdates: waUpdates }
                if (!profileExist) otpData['userName'] = userName
                props.navigation.navigate(ScreenRoute.otp, otpData);
                AlertService.loaderModal.setLoader(false)
            }, err => {
                AlertService.loaderModal.setLoader(false)
            }
            );

    }
    const toggleSwitch = () => {
        waUpdatesSet(!waUpdates);
    }

    let phoneNumberInputRef = useRef(null)

    useEffect(() => {
        phoneNumberInputRef.current?.focus();
    }, [])

    return (
        <View style={{ height: window.innerHeight, backgroundColor: AppTheme.color.background }}>

            <CommonHeader navigation={props.navigation} />

            <View style={{ backgroundColor: AppTheme.color.background, paddingVertical: 16, paddingHorizontal: 16, marginTop: AppTheme.headerHeight }}>

                <Text style={TextStyle.text16xb}>Login, In Just Two Steps</Text>
                <View style={{ height: 12 }} />
                <Text style={{ fontSize: 14 }}>We are happy to have you, please login to continue</Text>
                <View style={{ height: 31 }} />

                <View style={[AppStyles.mediumShadow, { backgroundColor: 'white', padding: 16, borderRadius: 12 }]}>
                    <PhoneNumberTextInput inputRef={phoneNumberInputRef}
                        phoneNumber={phoneNumber} onChangeText={onChangePhoneNumber} />
                    {profileExist != null && !profileExist ?
                        <NameTextInput name={userName} onChangeText={setName} viewStyle={{ marginTop: 16 }} /> : null}
                    <View style={{ height: 16 }} />
                    {
                        enabled ? <Pressable onPress={() => { onSendOTP() }}>
                            <LinearGradient colors={[AppTheme.color.primary, AppTheme.color.blue.darkBlue]} start={{ x: 0.0, y: 0.5 }} end={{ x: 1.0, y: 0.5 }}
                                style={{ width: AppTheme.appWidth - 64, borderRadius: 40, paddingVertical: 14, alignItems: 'center' }}>
                                <Text style={{ fontSize: 14, color: 'white', fontWeight: 'bold' }}>Send OTP</Text>
                            </LinearGradient></Pressable> :
                            <View style={{ width: AppTheme.appWidth - 64, borderRadius: 40, paddingVertical: 14, alignItems: 'center', backgroundColor: AppTheme.color.grey.disable }}>
                                <Text style={{ fontSize: 14, color: 'white', fontWeight: 'bold' }}>Send OTP</Text>
                            </View>
                    }
                    <View style={{ height: 24 }} />
                    <View style={[AppStyles.flexRow, {}]}>
                        <Image source={{ uri: getImagePath('/images/icons/whatsapp/encircled.svg'), width: 40, height: 40 }} />
                        <View style={{ width: 8 }} />
                        <View style={{ margin: 3, alignItems: 'flex-start', }}> <Text style={[{ fontSize: 14, fontWeight: 'bold', width: AppTheme.appWidth - 158 }]}>
                            Get updates on WhatsApp</Text></View>
                        <View style={{ width: 8 }} />
                        <View style={{ margin: 5, alignItems: 'flex-end', justifyContent: 'flex-end', position: "absolute", "right": 0 }}>
                            <Switch
                                trackColor={{ true: 'lightblue', false: 'grey' }}
                                onValueChange={toggleSwitch}
                                value={waUpdates} />
                        </View>
                    </View>
                </View>

                <View style={[styles.footer, { position: 'fixed', bottom: 24 }]}>
                    <Text style={{
                        fontSize: 12,
                        color: AppTheme.color.grey.text,
                        flexWrap: "wrap",
                        width: AppTheme.appWidth - 48
                    }}>By continuing, you agree to the
                        <Text> <Text
                            onPress={() =>
                                Linking.openURL('https://www.medcords.com/terms.html')}
                            style={{
                                fontSize: 12, fontWeight: '500',
                                color: AppTheme.color.primary,
                                borderBottomWidth: 0, paddingLeft: 4
                            }}>
                            Terms & Conditions</Text> and<Text
                                onPress={() =>
                                    Linking.openURL('https://www.medcords.com/privacypolicy.html')}
                                style={{
                                    fontSize: 12, fontWeight: '500',
                                    color: AppTheme.color.primary,
                                    borderBottomWidth: 0, paddingLeft: 4
                                }}>
                                Privacy Policy</Text>
                        </Text>
                    </Text>
                </View>
            </View>
        </View>
    )
}


const styles = StyleSheet.create(addFontFamilyStyle({
    mainContainer: { flex: 1, marginHorizontal: 15, marginVertical: 0 },

    mob_num_placeholer: {
        color: AppTheme.color.lightGreyColor, top: -7,
        position: 'absolute',
        zIndex: 900,
        backgroundColor: 'white',
        width: 90,
        left: 16,
        paddingLeft: 5
    },
    loginAayuLogo: { marginVertical: 70, marginHorizontal: 34 },
    footer: {
        height: 40,
        // left: 0, 
        alignSelf: "center",
        textAlign: 'center'
    },
    btnText: {
        color: "white", fontSize: 14, fontWeight: '500', textAlign: 'center', borderRadius: 23,
        paddingVertical: 19, lineHeight: 1.14, letterSpacing: 1.24, paddingHorizontal: 31
    }
}))

const mapStateToProps = (state) => ({ userDetails: state.userDetails, familyMembers: state.familyMembers })
const mapDispatchToProps = (dispatch) => ({
    addUserdetails: (user: any) => dispatch({
        type: UPDATE_USER_DETAILS,
        payload: {
            user
        }
    })
})

const connectComponent = connect(mapStateToProps, mapDispatchToProps);

export default connectComponent(LoginScreen)